import React from "react";
import {
  Layout,
  Row,
  Col,
  Menu,
  Image,
  Typography,
  Divider,
  Tabs,
  Input,
  Button,
} from "antd";
import styles from "./ESGTools.module.scss";
import { MarketPlace } from "../../Components/MarketPlace/MarketPlace";
import { mockData } from "./mock";
import { Title } from "../Title/Title";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";

export const ESGTools = () => {
  const { toolsList } = mockData;
  const navigate = useNavigate();

  return (
    <>
      <div
        id="esg-hub"
        className="esg-hub"
        style={{ background: "#fff", paddingTop: 40, paddingBottom: 20 }}
      >
        <Row>
          <Col lg={2}></Col>
          <Col lg={20} sm={24}>
            <Title title="DECARB TOOLS HUB" width={500} variant={2} />
            <div style={{}}>
              <Typography.Text style={{ color: "#003087" }} className="text">
                A Platform-as-a-service to track, trace and account for
                operational and embodied carbon across the project life cycle.
                Decarb Tools Hub armed with KPMG Assessment Tools and
                Sustainable Materials.
              </Typography.Text>
            </div>
            <div>
              <MarketPlace />
            </div>
            <div style={{ display: "flex" }} className="esg-hub-content">
              <div style={{ paddingTop: 40, width: "100%" }}>
                <Row>
                  <Col md={24}>
                    <Typography.Title
                      level={3}
                      style={{ color: styles.graphBlue, marginBottom: 20 }}
                    >
                      KPMG Decarb Assessment Tools​
                    </Typography.Title>
                    <Row gutter={[24, 0]}>
                      {toolsList &&
                        toolsList.map((item: any, index: number) => {
                          return (
                            <Col
                              md={12}
                              sm={24}
                              key={index}
                              style={{ marginBottom: 20 }}
                            >
                              <div
                                key={index}
                                style={{
                                  height: "100%",
                                  background: "#F9FBFD",
                                  border: "1px solid #EDEEF0",
                                  borderRadius: 17,
                                  padding: "10px 20px",
                                  cursor: "pointer",
                                }}
                                onClick={() => (window.location.href = "http://40.119.250.159:8085/")}
                              >
                                <Fade
                                  cascade={true}
                                  damping={0.1}
                                  direction="up"
                                  triggerOnce
                                >
                                  {/* <Button
                                  type="default"
                                  style={{
                                    background: "transparent",
                                    border: "1px solid #003087",
                                    color: "#003087",
                                    marginBottom: 10,
                                  }}
                                >
                                  {item.label}
                                </Button> */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: "#ACEAFF",
                                        borderTopLeftRadius: 20,
                                        borderBottomLeftRadius: 20,
                                        padding: "4px 12px",
                                        marginRight: -20,
                                      }}
                                    >
                                      <Typography.Text
                                        style={{
                                          marginBottom: 0,
                                          color: "#003087",
                                        }}
                                        className="textSmall"
                                      >
                                        {item.label}
                                      </Typography.Text>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: 20,
                                      alignItems: "center",
                                    }}
                                  >
                                    <div style={{ width: 160 }}>
                                      <Image src={item.icon} preview={false} />
                                    </div>
                                    <div style={{ width: "100%" }}>
                                      <Typography.Title
                                        level={4}
                                        style={{ color: "#003087" }}
                                      >
                                        {item.title}
                                      </Typography.Title>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      marginBottom: 10,
                                    }}
                                  >
                                    <Typography.Text
                                      style={{
                                        width: 160,
                                        color: "#1E49E2",
                                        fontWeight: 600,
                                      }}
                                    >
                                      Description:
                                    </Typography.Text>
                                    <Typography.Text
                                      style={{
                                        width: "100%",
                                        color: "#5F5F5F",
                                      }}
                                    >
                                      <span>{item.description}</span>
                                    </Typography.Text>
                                  </div>
                                  <div
                                    style={{ display: "flex", marginBottom: 0 }}
                                  >
                                    <Typography.Text
                                      style={{
                                        width: 160,
                                        color: "#1E49E2",
                                        fontWeight: 600,
                                      }}
                                    >
                                      Sector:
                                    </Typography.Text>
                                    <Typography.Text
                                      style={{
                                        width: "100%",
                                        color: "#5F5F5F",
                                      }}
                                    >
                                      <span>{item.sector}</span>
                                    </Typography.Text>
                                  </div>
                                  <div
                                    style={{ display: "flex", marginBottom: 0 }}
                                  >
                                    <Typography.Text
                                      style={{
                                        width: 160,
                                        color: "#1E49E2",
                                        fontWeight: 600,
                                      }}
                                    >
                                      Service Provider:
                                    </Typography.Text>
                                    <Typography.Text
                                      style={{
                                        width: "100%",
                                        color: "#5F5F5F",
                                      }}
                                    >
                                      <span>KPMG</span>
                                    </Typography.Text>
                                  </div>
                                </Fade>
                              </div>
                            </Col>
                          );
                        })}
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={2} sm={24}></Col>
        </Row>
      </div>
    </>
  );
};
